<template>
  <section class="section-wrapp">
  <Breadcrumbs :parameters=breadcrumbs></Breadcrumbs>
  <section class="section-add-station">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="background-shadow">
            <div class="row">
              <div class="col-12">
                <div class="add-station__title">{{(currentStation === null) ? 'Новая станция' : currentStation.title}}</div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 add-station-form">
                <form action="">
                  <div class="add-station-form__block">
                    <div class="row">
                      <div class="col-12 col-md-5 col-lg-4">
                        <div class="input-wr">
                          <label for="station-title">Название станции</label>
                          <input type="text" id="station-title" v-model="station.title">
                        </div>
                        <div class="input-wr">
                          <label for="station-power">Мощность (МВт)</label>
                          <input type="text" id="station-power" v-model="station.power">
                        </div>
                        <div class="input-wr">
                          <label for="station-dcpower">Мощность DC (МВт)</label>
                          <input type="text" id="station-dcpower" v-model="station.dcPower">
                        </div>
                        <div class="input-wr">
                          <label for="station-register">Регистр ограничения мощности</label>
                          <input type="text" id="station-register" v-model="station.powerRestrictionId">
                        </div>
                        <div class="input-wr">
                          <label for="power-type-control">Регистр режима регулировки мощности</label>
                          <input type="text" id="power-type-control" v-model="station.powerTypeControl.id">
                        </div>
                        <div class="input-wr checkbox-users" v-for="controlType in controlTypes" v-bind:key="controlType.id">
                          <input type="checkbox" :id="'control-typ-' + controlType.id" :value=controlType.id v-model="station.powerTypeControl.allowed">
                          <label :for="'control-typ-' + controlType.id">{{controlType.label}}</label>
                        </div>
                        <div class="input-wr">
                          <label for="station-lat">Широта</label>
                          <input type="text" id="station-lat" v-model="station.latitude">
                        </div>
                        <div class="input-wr">
                          <label for="station-long">Долгота</label>
                          <input type="text" id="station-long" v-model="station.longitude">
                        </div>
                        <div class="input-wr">
                          <label for="station-desc">Описание</label>
                          <textarea id="station-desc" v-model="station.description"></textarea>
                        </div>
                      </div>
                    </div>
                      <div v-if="currentStation === null" class="col-12">
                        <div class="calendar-save text-center">
                          <span class="confirm" @click="saveWithoutConfig()">сохранить</span>
                        </div>
                      </div>
                      <div v-else class="col-12">
                        <div class="calendar-save text-center">
                          <span class="confirm" @click="reconfigure">сохранить</span>
                        </div>
                      </div>
                    <ProductionCalendar :station-id="stationId"></ProductionCalendar>
                  </div>
                </form>
              </div>
            </div>
            <div v-if="configured" class="row">
              <div class="col-12">
                <div class="add-station-second-block-title">Найдено 24 устройства</div>
              </div>
              <div class="col-12 change-station-devices">
                <form @submit="reconfigure" action="">
                  <div class="row">
                    <div v-for="deviceColumn in devices" :key="deviceColumn.id" class="col-12 col-lg-4">
                      <div class="row">
                        <DeviceConfig v-for="device in deviceColumn" :device="device" :types="types" :key="device.id"></DeviceConfig>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <div class="button-wr">
                        <button type="submit">переконфигурировать</button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div v-else class="row">
              <div class="col-12">
                <div class="add-station-second-block-title">Для получения всех устройств станции укажите параметры</div>
              </div>
              <div class="col-12 add-station-api">
                <form @submit="createStation" action="">
                  <div class="row">
                    <div class="col-12 col-md-5 col-lg-4">
                      <div class="add-station-api-form">
                        <div class="add-station-api-form__bg">
                          <div class="input-wr">
                            <label for="s7">URL</label>
                            <input type="text" id="s7" v-model="station.link">
                          </div>
                          <div class="input-wr">
                            <label for="s8">API</label>
                            <input type="text" id="s8" v-model="station.apiKey">
                          </div>
                          <div class="button-wr">
                            <button type="submit">Отправить</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  </section>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs'
import DeviceConfig from '@/components/station-create/DeviceConfig'
import StationAPI from '@/api/station'
import ProductionCalendar from '@/components/station-create/ProductionCalendar'
import moment from 'moment'
import 'moment/locale/ru'
export default {
  name: 'StationSave',
  components: { Breadcrumbs, DeviceConfig, ProductionCalendar },
  data () {
    return {
      station: {
        title: '',
        power: '',
        apiKey: '',
        link: '',
        description: '',
        latitude: '',
        longitude: '',
        dcPower: '',
        powerRestrictionId: '',
        powerTypeControl: {
          id: '',
          allowed: []
        }
      },
      controlTypes: [
        {
          id: 4,
          label: 'Операційна безпека'
        },
        {
          id: 1,
          label: 'Рівнорозподілене керування'
        },
        {
          id: 2,
          label: 'EOV main'
        },
        {
          id: 3,
          label: 'EOV reserve'
        }
      ],
      forecast: null,
      askoe: null,
      currentMonth: null
    }
  },
  mounted () {
    this.getStation()
    this.setCurrentMonth()
  },
  computed: {
    currentStation () {
      return this.$store.getters['station/station']
    },
    month () {
      return {
        days: moment(this.currentMonth, 'M').daysInMonth(),
        title: moment(this.currentMonth, 'M').format('MMMM')
      }
    },
    configured () {
      return Array.isArray(this.$store.getters['station/devices']) && this.$store.getters['station/devices'].length > 0
    },
    types () {
      return [
        {
          id: 1,
          title: 'Satec'
        },
        {
          id: 2,
          title: 'Inverter'
        }
      ]
    },
    devices () {
      return this.$store.getters['station/devices']
    },
    breadcrumbs () {
      return [
        {
          url: '#',
          title: 'Station'
        }
      ]
    },
    stationId () {
      return Number(this.$route.params.id)
    }
  },
  watch: {
    $route: 'getStation'
  },
  methods: {
    saveAskoe (e) {
      e.preventDefault()
      let currentObj = this

      StationAPI.saveAskoe(this.$route.params.id,
        { 'askoe': this.askoe }
      )
        .then(() => {
          currentObj.$notify({
            group: 'foo',
            title: 'Успех',
            text: 'Прогноз АСКУЭ сохранен'
          })
        })
        .catch((error) => {
          currentObj.$notify({
            group: 'foo',
            title: 'Ошибка!',
            text: error
          })
        })
    },
    saveForecast (e) {
      e.preventDefault()
      let currentObj = this

      StationAPI.saveForecast(this.$route.params.id,
        { 'forecast': this.forecast }
      )
        .then(() => {
          currentObj.$notify({
            group: 'foo',
            title: 'Успех',
            text: 'Прогноз сохранен'
          })
        })
        .catch((error) => {
          currentObj.$notify({
            group: 'foo',
            title: 'Ошибка!',
            text: error
          })
        })
    },
    setCurrentMonth () {
      this.currentMonth = moment().month() + 1
    },
    changeCurrentMonth (next) {
      this.currentMonth += next
      if (this.currentMonth <= 0) { this.currentMonth = 1 }
      if (this.currentMonth >= 13) { this.currentMonth = 12 }
    },
    getStation () {
      let _this = this

      if (this.$route.name === 'station-edit') {
        let id = this.$route.params.id
        this.$store.dispatch('station/findOne', id)
          .then(() => {
            _this.station = _this.$store.getters[ 'station/station' ]
            if (_this.station.powerTypeControl === null) {
              _this.station.powerTypeControl = {
                id: '',
                allowed: []
              }
            }

            _this.forecast = Array.isArray(_this.station.forecast) ? {} : _this.station.forecast
            _this.askoe = Array.isArray(_this.station.askoe) ? {} : _this.station.askoe
          })
      }
    },
    saveWithoutConfig () {
      let _this = this
      StationAPI.create({
        'title': this.station.title,
        'power': this.station.power,
        'description': this.station.description,
        'latitude': this.station.latitude,
        'longitude': this.station.longitude,
        'dcPower': this.station.dcPower,
        'powerRestrictionId': this.station.powerRestrictionId,
        'powerTypeControl': this.station.powerTypeControl
      })
        .then((response) => {
          _this.$notify({
            group: 'foo',
            title: 'Успех',
            text: 'Станция сконфигурирована'
          })
          _this.$router.push('/station-edit/' + response.data)
        })
        .catch((error) => {
          _this.$notify({
            group: 'foo',
            title: 'Ошибка!',
            text: error
          })
        })
    },
    createStation (e) {
      e.preventDefault()
      let currentObj = this
      StationAPI.create({
        'title': this.station.title,
        'link': this.station.link,
        'apiKey': this.station.apiKey,
        'power': this.station.power,
        'description': this.station.description,
        'latitude': this.station.latitude,
        'longitude': this.station.longitude,
        'dcPower': this.station.dcPower,
        'powerRestrictionId': this.station.powerRestrictionId,
        'powerTypeControl': this.station.powerTypeControl
      })
        .then((response) => {
          currentObj.$notify({
            group: 'foo',
            title: 'Успех',
            text: 'Станция сконфигурирована'
          })
          currentObj.$router.push('/station-edit/' + response.data)
        })
        .catch((error) => {
          currentObj.$notify({
            group: 'foo',
            title: 'Ошибка!',
            text: error
          })
        })
    },
    reconfigure (e) {
      e.preventDefault()
      let currentObj = this
      StationAPI.edit(this.$route.params.id, {
        'title': this.station.title,
        'power': this.station.power,
        'description': this.station.description,
        'latitude': this.station.latitude,
        'longitude': this.station.longitude,
        'dcPower': this.station.dcPower,
        'powerRestrictionId': this.station.powerRestrictionId,
        'powerTypeControl': this.station.powerTypeControl
      })
        .then(() => {
          currentObj.$notify({
            group: 'foo',
            title: 'Успех',
            text: 'Станция сохранена'
          })
        })
        .catch((error) => {
          currentObj.$notify({
            group: 'foo',
            title: 'Ошибка!',
            text: error
          })
        })
    }
  }
}
</script>
